var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app-bar",
    {
      class: ["ml-0", "pl-3"],
      attrs: { app: "", height: "48px", fixed: "", "clipped-left": "" },
    },
    [
      _c(
        "v-app-bar-title",
        [
          _c(
            "router-link",
            {
              staticStyle: {
                "margin-right": "3px",
                color: "inherit",
                "text-decoration": "none",
              },
              attrs: { to: "/" },
            },
            [_vm._v("Protein Interface Clusters")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("img", {
        staticStyle: {
          "margin-left": "8px",
          display: "inline-block",
          width: "48px",
          height: "48px",
          "vertical-align": "middle",
        },
        attrs: {
          src: require("./assets/marv-foldseek-small.png"),
          "aria-hidden": "true",
        },
      }),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _c(
        "v-toolbar-items",
        { staticClass: "hidden-sm-and-down" },
        [
          _vm._l(_vm.links, function (link) {
            return [
              link.children
                ? _c(
                    "v-menu",
                    {
                      key: link.title,
                      attrs: { "offset-y": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g({ attrs: { text: "" } }, on),
                                  [
                                    _vm._v(_vm._s(link.title)),
                                    _c("v-icon", { attrs: { right: "" } }, [
                                      _vm._v(_vm._s(_vm.$MDI.ChevronDown)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-list",
                        _vm._l(link.children, function (child) {
                          return _c(
                            "v-list-item",
                            {
                              key: child.title,
                              attrs: {
                                href: child.href,
                                rel: "external noopener",
                                target: "_blank",
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(child.title)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      key: link.title,
                      attrs: {
                        text: "",
                        href: link.href,
                        rel: "external noopener",
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(link.title))]
                  ),
            ]
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                icon: "",
                rel: "external noopener",
                target: "_blank",
                href: "https://github.com/steineggerlab/foldseek",
              },
            },
            [_c("v-icon", [_vm._v(_vm._s(_vm.$MDI.GitHub))])],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          staticClass: "hidden-md-and-up",
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      { staticClass: "hidden-md-and-up", attrs: { icon: "" } },
                      on
                    ),
                    [_c("v-icon", [_vm._v(_vm._s(_vm.$MDI.DotsVertical))])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            [
              _vm._l(_vm.links, function (link) {
                return [
                  link.children
                    ? _c(
                        "v-list-group",
                        {
                          key: link.title,
                          attrs: { "no-action": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(link.title)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _vm._l(link.children, function (child) {
                            return _c(
                              "v-list-item",
                              {
                                key: child.title,
                                attrs: {
                                  rel: "external noopener",
                                  target: "_blank",
                                  href: child.href,
                                },
                              },
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(child.title)),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _c(
                        "v-list-item",
                        {
                          key: link.title,
                          attrs: {
                            rel: "external noopener",
                            target: "_blank",
                            href: link.href,
                          },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(link.title)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ]
              }),
              _vm._v(" "),
              _c(
                "v-list-item",
                {
                  attrs: {
                    rel: "external noopener",
                    target: "_blank",
                    href: "https://github.com/steineggerlab/foldseek",
                  },
                },
                [
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v("GitHub")])],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }